// Live activity of LIA (owner request 2026-11-03 + context/v1.1 ficha «tareas de LÍA para hoy y vencidas»): what LIA is
// doing right now (a running step, like a model «thinking»), what it just did, and its tasks. Browser-safe.
import { z } from 'zod';
import { SetterTaskSchema } from './setter-tasks.js';

export const ACTIVITY_KINDS = ['turn', 'step', 'cadence', 'crm', 'task', 'lead'] as const;
export const ActivityKindSchema = z.enum(ACTIVITY_KINDS);
export type ActivityKind = z.infer<typeof ActivityKindSchema>;

export const ACTIVITY_STATUSES = ['running', 'done', 'failed', 'skipped'] as const;
export const ActivityStatusSchema = z.enum(ACTIVITY_STATUSES);
export type ActivityStatus = z.infer<typeof ActivityStatusSchema>;

export const ActivitySchema = z.object({
  id: z.string(),
  parentId: z.string().nullable(),
  kind: ActivityKindSchema,
  status: ActivityStatusSchema,
  label: z.string(),
  detail: z.string().nullable(),
  projectId: z.string().nullable(),
  projectName: z.string().nullable(),
  contactId: z.string().nullable(),
  contactName: z.string().nullable(),
  leadInterestId: z.string().nullable(),
  taskId: z.string().nullable(),
  isTest: z.boolean(),
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
});
export type ActivityDto = z.infer<typeof ActivitySchema>;

export const ActivityQuerySchema = z.object({
  projectId: z.string().min(1).max(64).optional(),
  leadInterestId: z.string().min(1).max(64).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(60),
});
export type ActivityQuery = z.infer<typeof ActivityQuerySchema>;

export const ActivityFeedSchema = z.object({
  activities: z.array(ActivitySchema),
  tasks: z.object({
    /** Open tasks: overdue first, then by due time. */
    open: z.array(SetterTaskSchema),
    /** Recently closed tasks with their result. */
    recent: z.array(SetterTaskSchema),
  }),
  /** Open tasks whose due time passed (shown red: «vencidas»). */
  overdue: z.number().int(),
  /** Active opportunities without a scheduled next action (internal alert tasks). */
  missing: z.number().int(),
});
export type ActivityFeed = z.infer<typeof ActivityFeedSchema>;

/** Server-sent events on GET …/activity/stream: `activity` (an ActivityDto) and `task` (a SetterTaskDto). */
export const ACTIVITY_STREAM_EVENTS = ['activity', 'task'] as const;
